import { useLocalization } from '../../common/providers/LocaleProvider';
/** Backward compatibility!!! Remove when all pages will use new version of newsletter signup */
export var usePropOrTranslation = function (_a) {
    var headline = _a.headline, subline = _a.subline, asteriskText = _a.asteriskText;
    var _b = useLocalization(), r = _b.r, t = _b.t, prefix = _b.prefix;
    return {
        headline: headline ? headline : t('h24_newsletter_headline'),
        subline: subline
            ? subline
            : r(t('h24_newsletter_message'), {
                h24_newsletter_message_link: t('h24_newsletter_message_link'),
                h24_newsletter_message_link_url: prefix.t('h24_newsletter_message_link_url'),
            }),
        asteriskText: asteriskText
            ? asteriskText
            : t('h24_newsletter_voucher_disclaimer'),
    };
};
